// utils/errorLogger.js

export function logError(error) {
  // Use the original error's stack trace, not a new one
  const stack = error.stack;
  
  if (stack) {
    // Parse the original error's stack to find where it actually occurred
    const stackLines = stack.split('\n');
    
    // Look through the stack lines to find the first relevant file (skip axios internal calls)
    for (let i = 0; i < stackLines.length; i++) {
      const line = stackLines[i];
      
      // Skip axios internal calls, look for our actual code
      if (line.includes('node_modules') || line.includes('axios.js')) {
        continue;
      }
      
      // Pattern for Vite dev server format: "at async ActionCommercialApi.updateActionCommercial (http://localhost:5010/src/api/ActionCommercialApi.js?t=1748541037761:11:24)"
      const vitePattern = /at\s+(?:async\s+)?.*?\s+\(.*?\/([^/?]+\.(?:js|jsx|ts|tsx))\?[^:]*:(\d+):\d+\)/;
      const match = line.match(vitePattern);
      
      if (match) {
        const filename = match[1];
        const lineNumber = match[2];
        console.error(`error in ${filename} -> ${lineNumber}: `, error);
        return;
      }
      
      // Fallback pattern for production builds
      const generalPattern = /([^/\\]*\.(?:js|jsx|ts|tsx)):(\d+):\d+/;
      const generalMatch = line.match(generalPattern);
      if (generalMatch) {
        const filename = generalMatch[1];
        const lineNumber = generalMatch[2];
        console.error(`error in ${filename} -> ${lineNumber}: `, error);
        return;
      }
    }
  }
  
  // Fallback if parsing fails
  console.error("error in unknown -> unknown: ", error);
}

export function logErrorSimple(error, context = '') {
  const errorType = error.constructor.name || 'Error';
  const message = error.message || 'Unknown error';
  
  if (context) {
    console.error(`error in ${context}: [${errorType}] ${message}`, error);
  } else {
    console.error(`error: [${errorType}] ${message}`, error);
  }
}